import { useUserStore } from '../store/modules/user';
import dayjs from 'dayjs';
import { getImageUrl } from '../api/shared';
/**
 * 获取指定格式的当前时间字符串
 * @returns string
 */
export function getFormattedDate() {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, '0'); // 补零
    const day = String(today.getDate()).padStart(2, '0'); // 补零
    return `${year}_${month}_${day}`; // 格式如：2025_05_09
}
/**
 * @description 格式化时间
 * @param time
 * @param cFormat
 * @returns {string|null}
 */
export function parseTime(time, cFormat) {
    if (arguments.length === 0) {
        return null;
    }
    const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}';
    let date;
    if (typeof time === 'object') {
        date = time;
    }
    else {
        if (typeof time === 'string' && /^[0-9]+$/.test(time)) {
            time = parseInt(time);
        }
        if (typeof time === 'number' && time.toString().length === 10) {
            time = time * 1000;
        }
        date = new Date(time);
    }
    const formatObj = {
        y: date.getFullYear(),
        m: date.getMonth() + 1,
        d: date.getDate(),
        h: date.getHours(),
        i: date.getMinutes(),
        s: date.getSeconds(),
        a: date.getDay(),
    };
    return format.replace(/{([ymdhisa])+}/g, (result, key) => {
        let value = formatObj[key];
        if (key === 'a') {
            return ['日', '一', '二', '三', '四', '五', '六'][value];
        }
        if (result.length > 0 && value < 10) {
            value = `0${value}`;
        }
        return value || 0;
    });
}
/**
 * @description 格式化时间
 * @param time
 * @param option
 * @returns {string}
 */
export function formatTime(time, option) {
    if (`${time}`.length === 10) {
        time = parseInt(time) * 1000;
    }
    else {
        time = +time;
    }
    const d = new Date(time);
    const now = Date.now();
    const diff = (now - d) / 1000;
    if (diff < 30) {
        return '刚刚';
    }
    else if (diff < 3600) {
        // less 1 hour
        return `${Math.ceil(diff / 60)}分钟前`;
    }
    else if (diff < 3600 * 24) {
        return `${Math.ceil(diff / 3600)}小时前`;
    }
    else if (diff < 3600 * 24 * 2) {
        return '1天前';
    }
    if (option) {
        return parseTime(time, option);
    }
    else {
        return `${d.getMonth() + 1}月${d.getDate()}日${d.getHours()}时${d.getMinutes()}分`;
    }
}
/**
 * @description 格式化指定天数日期
 * @param day
 * @returns {string}
 */
export function formatDate(day, month = 0) {
    const date = new Date();
    if (month != 0) {
        date.setMonth(date.getMonth() + month);
    }
    if (day != 0) {
        date.setDate(date.getDate() + day);
    }
    return parseTime(date, '{y}/{m}/{d}');
}
export const dateFormat = (date, format = 'YYYY/MM/DD HH:mm:ss') => {
    if (!date)
        return '';
    return dayjs(date).format(format);
};
/**
 * @description 将url请求参数转为json格式
 * @param url
 * @returns {{}|any}
 */
export function paramObj(url) {
    const search = url.split('?')[1];
    if (!search) {
        return {};
    }
    return JSON.parse(`{"${decodeURIComponent(search)
        .replace(/"/g, '\\"')
        .replace(/&/g, '","')
        .replace(/=/g, '":"')
        .replace(/\+/g, ' ')}"}`);
}
/**
 * @description 父子关系的数组转换成树形结构数据
 * @param data
 * @returns {*}
 */
export function translateDataToTree(data) {
    const parent = data.filter((value) => value.parentId === 'undefined' || value.parentId === null);
    const children = data.filter((value) => value.parentId !== 'undefined' && value.parentId !== null);
    const translator = (parent, children) => {
        parent.forEach((parent) => {
            children.forEach((current, index) => {
                if (current.parentId === parent.id) {
                    const temp = JSON.parse(JSON.stringify(children));
                    temp.splice(index, 1);
                    translator([current], temp);
                    typeof parent.children !== 'undefined'
                        ? parent.children.push(current)
                        : (parent.children = [current]);
                }
            });
        });
    };
    translator(parent, children);
    return parent;
}
/**
 * @description 树形结构数据转换成父子关系的数组
 * @param data
 * @returns {[]}
 */
export function translateTreeToData(data) {
    const result = [];
    data.forEach((item) => {
        const loop = (data) => {
            result.push({
                id: data.id,
                name: data.name,
                parentId: data.parentId,
            });
            const child = data.children;
            if (child) {
                for (let i = 0; i < child.length; i++) {
                    loop(child[i]);
                }
            }
        };
        loop(item);
    });
    return result;
}
/**
 * @description 10位时间戳转换
 * @param time
 * @returns {string}
 */
export function tenBitTimestamp(time) {
    const date = new Date(time * 1000);
    const y = date.getFullYear();
    let m = date.getMonth() + 1;
    m = m < 10 ? `${m}` : m;
    let d = date.getDate();
    d = d < 10 ? `${d}` : d;
    let h = date.getHours();
    h = h < 10 ? `0${h}` : h;
    let minute = date.getMinutes();
    let second = date.getSeconds();
    minute = minute < 10 ? `0${minute}` : minute;
    second = second < 10 ? `0${second}` : second;
    return `${y}年${m}月${d}日 ${h}:${minute}:${second}`; //组合
}
/**
 * @description 13位时间戳转换
 * @param time
 * @returns {string}
 */
export function thirteenBitTimestamp(time) {
    const date = new Date(time / 1);
    const y = date.getFullYear();
    let m = date.getMonth() + 1;
    m = m < 10 ? `${m}` : m;
    let d = date.getDate();
    d = d < 10 ? `${d}` : d;
    let h = date.getHours();
    h = h < 10 ? `0${h}` : h;
    let minute = date.getMinutes();
    let second = date.getSeconds();
    minute = minute < 10 ? `0${minute}` : minute;
    second = second < 10 ? `0${second}` : second;
    return `${y}年${m}月${d}日 ${h}:${minute}:${second}`; //组合
}
/**
 * @description 获取随机id
 * @param length
 * @returns {string}
 */
export function uuid(length = 32) {
    const num = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ1234567890';
    let str = '';
    for (let i = 0; i < length; i++) {
        str += num.charAt(Math.floor(Math.random() * num.length));
    }
    return str;
}
/**
 * @description m到n的随机数
 * @param m
 * @param n
 * @returns {number}
 */
export function random(m, n) {
    return Math.floor(Math.random() * (m - n) + n);
}
/**
 * @description 数组打乱
 * @param array
 * @returns {*}
 */
export function shuffle(array) {
    let m = array.length, t, i;
    while (m) {
        i = Math.floor(Math.random() * m--);
        t = array[m];
        array[m] = array[i];
        array[i] = t;
    }
    return array;
}
/**
 * 深拷贝对象
 */
export function deepCopy(obj) {
    return JSON.parse(JSON.stringify(obj));
}
/**生成GUID */
export const getGuid = () => {
    let d = new Date().getTime();
    const uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
        const r = ((d + Math.random() * 16) % 16) | 0;
        d = Math.floor(d / 16);
        return (c == 'x' ? r : (r & 0x3) | 0x8).toString(16);
    });
    return uuid;
};
/**
 * 空GUID
 */
export const GuidEmpty = '00000000-0000-0000-0000-000000000000';
export const Symbols = {
    '=': '=',
    '>=': '>=',
    '<=': '<=',
    '>': '>',
    '<': '<',
    like: '包含',
};
export const SymbolOptions = Object.entries(Symbols).map(([value, label]) => ({
    value,
    label,
}));
/**
 * 数字扁平化输出
 * @param input
 * @param separator
 * @returns
 */
export const arrayToString = (input, separator = '，') => {
    if (typeof input === 'string') {
        try {
            const parsed = JSON.parse(input);
            input = Array.isArray(parsed) ? parsed : [input];
        }
        catch {
            input = [input];
        }
    }
    if (!Array.isArray(input)) {
        return String(input || '');
    }
    const result = input
        .filter((item) => item != null && item !== '')
        .map((item) => String(item).trim())
        .join(separator);
    const punctuation = ['，'];
    return result.replace(new RegExp(`[${punctuation.join('')}]+$`), '');
};
// 常用正则统一定义
export const regex = {
    email: /^[\w.-]+@[\w.-]+\.[a-zA-Z]{2,}$/,
    phone: /^1[3-9]\d{9}$/,
    idCard: /^\d{15}|\d{18}$/,
    number: /^\d+$/,
};
/**
 * 文件业务类型（与后端 EnumBuessFileType 对应）
 */
export var BuessFileType;
(function (BuessFileType) {
    /** App端上传图片 */
    BuessFileType["AppImage"] = "AppImage";
    /** App端上传文件 */
    BuessFileType["AppFile"] = "AppFile";
    /** 中心管理系统图片 */
    BuessFileType["SysManagement"] = "SysManagement";
    /** 租户系统 */
    BuessFileType["CloudEasyWeigh"] = "CloudEasyWeigh";
    /** 数据同步 */
    BuessFileType["SyncDataApi"] = "SyncDataApi";
    /** 客户 */
    BuessFileType["NewCustomer"] = "NewCustomer";
    /** 调价 */
    BuessFileType["AdjustmentPrice"] = "AdjustmentPrice";
    /** 销售订单 */
    BuessFileType["SaleOrder"] = "SaleOrder";
    /** 审批记录 */
    BuessFileType["ApprovalRecords"] = "ApprovalRecords";
    /** 缴费 */
    BuessFileType["NewPayment"] = "NewPayment";
    /** 销售价 */
    BuessFileType["SalePrice"] = "SalePrice";
    /** 批量磅单 */
    BuessFileType["BatchWeighMessage"] = "BatchWeighMessage";
    /** 操作日志 */
    BuessFileType["OperateLog"] = "OperateLog";
    /** 签章 */
    BuessFileType["Signatures"] = "Signatures";
    /** 电子磅单 */
    BuessFileType["ElectronicWeigh"] = "ElectronicWeigh";
    /** 客户结算 */
    BuessFileType["CustomerSettlement"] = "CustomerSettlement";
    /** 结算结果 */
    BuessFileType["SettlementResult"] = "SettlementResult";
    /** 结算发票 */
    BuessFileType["SettlementInvoice"] = "SettlementInvoice";
})(BuessFileType || (BuessFileType = {}));
/**
 * 构造文件上传专用 headers
 * @param fileType 文件业务类型（必传）
 * @param extra 额外参数（可选）
 */
export function uploadHeaders(fileType, extra = {}) {
    const userStore = useUserStore();
    return {
        Authorization: `Bearer ${userStore.token}`,
        TenantNumber: getTenant().tenantNumber,
        FileType: fileType, // 业务类型
        ...extra,
    };
}
export async function parseFileList(attachments) {
    if (!attachments?.length)
        return [];
    const results = await Promise.all(attachments.map(async (d) => {
        const url = await getImageUrl(d.value);
        return {
            fileName: d.name,
            name: d.value,
            url,
            path: d.value,
            uid: Date.now() + Math.random(),
        };
    }));
    return results;
}
export function getTenant() {
    try {
        const tenant = JSON.parse(sessionStorage.getItem(`tenant`));
        return tenant;
    }
    catch (ex) {
        console.warn('租户信息为空');
        // 考虑退出登录?
    }
}
export const convertKeysToPascalCase = (obj) => {
    if (!obj || typeof obj !== 'object')
        return obj;
    const result = {};
    for (let key in obj) {
        // 首字母大写
        const pascalKey = key.charAt(0).toUpperCase() + key.slice(1);
        result[pascalKey] = obj[key];
    }
    return result;
};
export const uploadingValidator = (fileList) => {
    return (rule, value, callback) => {
        if (fileList.value.some((f) => f.status === 'uploading')) {
            callback(new Error(rule.message || '文件上传中...，请等待完成后再保存'));
        }
        else {
            callback();
        }
    };
};
/**
 * 四舍五入方法
 * @param {number} value - 数值
 * @param {0|1|2} mode - 0:四舍五入 1:舍位 2:进位
 * @param {number} decimals - 小数位数
 */
export function roundNumber(value, mode = '0', decimals = 2) {
    const factor = Math.pow(10, decimals);
    switch (mode) {
        case '1':
            return Math.floor(value * factor) / factor;
        case '2':
            return Math.ceil(value * factor) / factor;
        default:
            return Math.round(value * factor) / factor;
    }
}
const _toFixed = Number.prototype.toFixed;
Number.prototype.toFixed = function (decimals = 2, mode) {
    if (mode === undefined)
        return _toFixed.call(this, decimals);
    const factor = Math.pow(10, decimals);
    console.log('自定义数字规范');
    switch (String(mode)) {
        case '1':
            return _toFixed.call(Math.floor(this * factor) / factor, decimals);
        case '2':
            return _toFixed.call(Math.ceil(this * factor) / factor, decimals);
        default:
            return _toFixed.call(Math.round(this * factor) / factor, decimals);
    }
};
//TODO:全局参数应当是前端自动缓存,业务模块无需单独获取传入
export const formatAmount = (value, decimals = 2, mode = 0) => {
    if (value == '***')
        return value;
    value = value ?? 0;
    // mode: 0-四舍五入 1-舍位 2-进位
    const factor = Math.pow(10, decimals);
    let rounded;
    switch (Number(mode)) {
        case 1: // 舍位
            rounded = Math.floor(value * factor) / factor;
            break;
        case 2: // 进位
            rounded =
                value >= 0
                    ? Math.ceil(value * factor) / factor
                    : Math.floor(value * factor) / factor;
            break;
        default: // 四舍五入
            rounded = Math.round(value * factor) / factor;
    }
    return new Intl.NumberFormat('zh-CN', {
        minimumFractionDigits: decimals,
        maximumFractionDigits: decimals,
    }).format(rounded);
};
